let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ik6sd")).then(() => parcelRequire('lwY85'));